import { immer } from "zustand/middleware/immer";

export type FeatureProps = {
  name: string;
  enabled: boolean;
  created_at?: string;
};
interface FeatureFlagState {
  featureFlags: Record<string, boolean>;
  whatsNewFeatureFlagCreatedAt: string | null;
}

interface FeatureFlagAction {
  setFeatureFlags: (data: Array<FeatureProps>) => void;
  setWhatsNewFeatureFlagCreatedAt: (date: string) => void;
}
export interface FeatureFlagInterface
  extends FeatureFlagState,
    FeatureFlagAction {}

export const featureFlagSlice = immer<FeatureFlagState & FeatureFlagAction>(
  (set) => ({
    featureFlags: {},
    whatsNewFeatureFlagCreatedAt: null,
    setFeatureFlags(data) {
      set((state) => {
        const featureObject = {};
        data.forEach((item: FeatureProps) => {
          // @ts-ignore
          featureObject[`${item.name}`] = item.enabled;
        });
        state.featureFlags = featureObject;
      });
    },
    setWhatsNewFeatureFlagCreatedAt(date) {
      set((state) => {
        state.whatsNewFeatureFlagCreatedAt = date;
      });
    },
  }),
);
